import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type AISeoGenerateRequest as SchemaAISeoGenerateRequest } from '../schemas/AISeoGenerateRequest';
import { type GenerateAISeoShortResponse as SchemaGenerateAISeoShortResponse } from '../schemas/GenerateAISeoShortResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Categories
 */
export const GenerateAISeoForCategoryContentType = 'application/json' as const;
export type GenerateAISeoForCategoryRequest = SchemaAISeoGenerateRequest;
export type GenerateAISeoForCategoryResponses = LinkCommonErrorResponses & {
    /**
     * @description Успешная генерация сео текстов
     */
    '200': {
        'application/json': SchemaGenerateAISeoShortResponse;
    };
};
export type GenerateAISeoForCategoryResponseSuccess = GenerateAISeoForCategoryResponses['200']['application/json'];
export type GenerateAISeoForCategorySearchParams = undefined;
export type GenerateAISeoForCategoryPathParameters = {
    id: string;
};
export const GenerateAISeoForCategoryUrl = '/categories/{id}/seo/ai/generate' as const;
export const GenerateAISeoForCategoryMethod = 'POST' as const;
export const getGenerateAISeoForCategoryUrl = (params: GenerateAISeoForCategoryPathParameters) =>
    GenerateAISeoForCategoryUrl.replace(/\{(\w+)\}/g, (_match, param: keyof GenerateAISeoForCategoryPathParameters) =>
        String(params[param])
    );
